import {
  DataTableColumnBadgeProps,
  DataTableColumnTextProps,
  DataTableColumnVariant,
  DataTableRowActions,
  DataTableServerQuery,
  DataTableVariant,
  DynamicDataTable,
  DynamicDataTableColumn,
} from '@/components/data-table-builder/data-table.types';
import { formatDate } from '@angular/common';
import { string } from '@/utils/string.utils';

interface IMeetingListDataTableProps {
  createAction?: () => void;
  rowActionsFn?: (...args: any[]) => DataTableRowActions;
  serverQuery?: DataTableServerQuery;
}

export const getMeetingListDataTableStructure = ({ createAction, rowActionsFn, serverQuery }: IMeetingListDataTableProps): DynamicDataTable => {
  const meetingByCommitteeIdColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'meeting.table.meetingComId',
    accessorKey: 'reunionNumCom',
    variant: DataTableColumnVariant.TEXT,
    renderAs: (value: string) => {
      return {
        value: value ?? '----',
      };
    },
  };

  const committeeColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'meeting.table.com',
    accessorKey: 'comName',
    variant: DataTableColumnVariant.TEXT,
    renderAs: (value: string) => {
      return {
        value: value ? string.truncate(string.stripHtml(value), 35) : '----',
      };
    },
  };

  const objectColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'meeting.table.object',
    accessorKey: 'object',
    variant: DataTableColumnVariant.TEXT,
    renderAs: (value: string) => {
      return {
        value: value ? string.truncate(string.stripHtml(value), 30) : '----',
      };
    },
  };

  const placeColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'meeting.table.emplacement',
    accessorKey: 'emplacement',
    variant: DataTableColumnVariant.TEXT,
    renderAs: (value: string) => {
      return {
        value: value ? string.truncate(string.stripHtml(value), 30) : '----',
      };
    },
  };

  const createdAtColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'meeting.table.createdAt',
    accessorKey: 'metadata.createdAt',
    variant: DataTableColumnVariant.TEXT,
    renderAs: (value: any) => {
      return {
        value: formatDate(value, 'dd/MM/yyyy', 'en-US'),
      };
    },
  };

  const meetingDateTimeColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'meeting.table.meeting_date_time',
    accessorKey: 'reunionDate',
    variant: DataTableColumnVariant.TEXT,
    renderAs: (value: any) => {
      return {
        value: value ? formatDate(value, 'dd/MM/yyyy HH:mm', 'en-US') : 'meeting.table.no_date_time',
      };
    },
    class: 'text-gray-500',
  };

  const statusColumn: DynamicDataTableColumn<DataTableColumnBadgeProps> = {
    label: 'meeting.table.status',
    accessorKey: 'status',
    variant: DataTableColumnVariant.TEXT,
    renderAs: (value: string) => {
      return {
        value: `meeting.status.${value}`,
      };
    },
  };

  return {
    singular: 'meeting.singular',
    plural: 'meeting.plural',
    variant: DataTableVariant.COMMON,
    sizes: [10, 20, 50],
    columns: [meetingByCommitteeIdColumn, committeeColumn, objectColumn, placeColumn, meetingDateTimeColumn, createdAtColumn, statusColumn],
    stripedRows: true,
    enableServerActions: true,
    serverQuery,
    createAction,
    rowActionsFn,
    searchableFields: ['ref', 'emplacement', 'reunionDate', 'createdAt', 'status'],
  };
};
